import { useEffect, useState } from "react";
import { SiGmail } from "react-icons/si";
import { FaWhatsappSquare } from "react-icons/fa";
import { CountryList } from "../utils/countrylist";
// const CountryList = [
//   {
//     isoCode: "tg",
//     name: "TOGO",
//     code: "+228",
//     digit: 8,
//     currency: "xof",
//     payments: [],
//   },
//   {
//     isoCode: "bj",
//     name: "BENIN",
//     code: "+229",
//     digit: 8,
//     currency: "xof",
//     payments: [],
//   },
//   {
//     isoCode: "cm",
//     name: "CAMEROON",
//     code: "+237",
//     digit: 9,
//     currency: "xaf",
//     payments: [],
//   },
//   {
//     isoCode: "sn",
//     name: "SENEGAL",
//     code: "+221",
//     digit: 9,
//     currency: "xof",
//     payments: [],
//   },
//   {
//     isoCode: "bf",
//     name: "BURKINA FASO",
//     code: "+226",
//     digit: 8,
//     currency: "xof",
//     payments: [],
//   },
//   {
//     isoCode: "ci",
//     name: "COTE D'IVOIRE",
//     code: "+225",
//     digit: 10,
//     currency: "xof",
//     payments: [],
//   },
//   {
//     isoCode: "ml",
//     name: "MALI",
//     code: "+223",
//     digit: 8,
//     currency: "xof",
//     payments: [],
//   },
// ];


export default function InitialPayment() {
  // États pour le numéro de base de l'utilisateur (non modifiable)
  const [userBasePhone, setUserBasePhone] = useState("");
  const [userBaseCode, setUserBaseCode] = useState("");
  const [userBaseCountryDetails, setUserBaseCountryDetails] = useState(null);
  const token = localStorage.getItem("token");

  // États pour le choix de l'utilisateur
  const [otherCountrySelected, selectOtherCountry] = useState(false);

  // États pour le numéro alternatif (si autre pays sélectionné)
  const [alternativeCountryDetails, setAlternativeCountryDetails] = useState(CountryList[0]);
  const [alternativePhoneNumber, setAlternativePhoneNumber] = useState("");

  // État pour la méthode de paiement
  const [paymentMethod, setPaymentMethod] = useState("");

  // États pour la gestion du paiement
  const [isLoading, setIsLoading] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [successMessage, setSuccessMessage] = useState("");
  const [countryList, setCountryList] = useState([]);
  // const [existingPayment, setExistingPayment] = useState(false);

  // const [isLoadingServices, setIsLoadingServices] = useState(true);

  const [isActive, setIsActive] = useState(() => {
    try {
      const user = JSON.parse(localStorage.getItem("user"));
      return user?.isActive || false;
    } catch {
      return false;
    }
  });

  const activationFee = 3300;
  const apiUrl = process.env.REACT_APP_CAPITALYA_API_URL;

  // useEffect(() => {
  //   const checkPaymentAndValidate = async () => {
  //     if (!token || isActive) return;

  //     try {
  //       // 1️⃣ Vérifier si un paiement est en cours/existant
  //       const inProcessRes = await fetch(`${apiUrl}/api/activation/check-if-payment`, {
  //         method: "GET",
  //         headers: {
  //           "Content-Type": "application/json",
  //           Authorization: `Bearer ${token}`,
  //         },
  //       });

  //       const inProcessData = await inProcessRes.json();
  //       setExistingPayment(inProcessData.existingPayment || false);

  //       // 2️⃣ Vérifier le statut du paiement
  //       const verifyRes = await fetch(`${apiUrl}/api/activation/verify-payment`, {
  //         method: "GET",
  //         headers: {
  //           "Content-Type": "application/json",
  //           Authorization: `Bearer ${token}`,
  //         },
  //       });

  //       const verifyData = await verifyRes.json();

  //       if (verifyRes.ok && verifyData.isActive) {
  //         setIsActive(true);

  //         const user = JSON.parse(localStorage.getItem("user")) || {};
  //         user.isActive = true;
  //         localStorage.setItem("user", JSON.stringify(user));

  //         setSuccessMessage("Paiement confirmé. Compte activé !");
  //       }

  //     } catch (err) {
  //       console.error("Erreur lors de la vérification du paiement :", err);
  //     }
  //   };

  //   checkPaymentAndValidate();
  // }, [apiUrl, token, isActive]);

  // useEffect(() => {
  //   const checkIfPaymentExists = async () => {
  //     if (!token || isActive) return;

  //     try {
  //       const res = await fetch(
  //         `${apiUrl}/api/activation/check-if-payment`,
  //         {
  //           method: "GET",
  //           headers: {
  //             "Content-Type": "application/json",
  //             Authorization: `Bearer ${token}`,
  //           },
  //         }
  //       );

  //       const data = await res.json();
  //       setExistingPayment(Boolean(data.existingPayment));

  //     } catch (err) {
  //       console.error("Erreur check-if-payment :", err);
  //     }
  //   };

  //   checkIfPaymentExists();
  // }, [apiUrl, token, isActive]);


  useEffect(() => {
    if (!token || isActive) return;

    const verifyPayment = async () => {
      try {
        const res = await fetch(
          `${apiUrl}/api/activation/verify-payment`,
          {
            method: "GET",
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${token}`,
            },
          }
        );

        const data = await res.json();

        if (res.ok && data.isActive) {
          setIsActive(true);

          const user = JSON.parse(localStorage.getItem("user")) || {};
          user.isActive = true;
          localStorage.setItem("user", JSON.stringify(user));

          setSuccessMessage("Paiement confirmé. Compte activé !");
        }

      } catch (err) {
        console.error("Erreur verify-payment :", err);
      }
    };

    verifyPayment();
  }, [apiUrl, token, isActive]);


  useEffect(() => {
    if (!token || isActive) return;

    const fetchServices = async () => {
      try {
        const response = await fetch(
          "https://express-qw8z.onrender.com/api/activation/services"
        );
        const data = await response.json();

        if (!response.ok) {
          console.error("Erreur lors de la récupération des services");
          // setIsLoadingServices(false);
          return;
        }

        const services = data.services.data.filter(
          service => service.is_active && service.country
        );

        // 🔥 recréer une liste propre (immutabilité)
        const updatedCountries = CountryList.map(country => ({
          ...country,
          payments: []
        }));

        // Associer les services
        services.forEach(service => {
          const country = updatedCountries.find(
            c => c.isoCode.toLowerCase() === service.country.code.toLowerCase()
          );

          if (country && !country.payments.includes(service.name)) {
            country.payments.push(service.name);
          }
        });

        setCountryList(updatedCountries);

        if (updatedCountries.length > 0) {
          setAlternativeCountryDetails(updatedCountries[0]);
        }

        // setIsLoadingServices(false);
      } catch (error) {
        console.error("Erreur fetch services :", error);
        // setIsLoadingServices(false);
      }
    };

    fetchServices();
  }, [isActive, token]); // ✅ PAS de dépendance


  useEffect(() => {
    if (!token || isActive) return;

    const fetchUserInfos = async () => {
      try {
        const response = await fetch(
          `${apiUrl}/api/activation/get-transaction-form-filling-infos`,
          {
            method: "GET",
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${token}`,
            },
          }
        );

        const data = await response.json();

        if (!response.ok) {
          console.error("Erreur : ", data.message);
          return;
        }

        const { name, code, digit, tel, isoCode } = data.infos;

        // 🔥 trouver le pays dans countryList
        const matchedCountry = countryList.find(
          c => c.code === code || c.isoCode === isoCode
        );

        const finalPayments = matchedCountry?.payments || [];

        setUserBasePhone(tel);
        setUserBaseCode(code);

        setUserBaseCountryDetails({
          name,
          code,
          digit,
          payments: finalPayments,
          isoCode
        });

        // méthode de paiement par défaut
        if (finalPayments.length > 0) {
          setPaymentMethod(finalPayments[0]);
        }


      } catch (err) {
        console.error("Erreur fetch infos :", err);
      }
    };

    fetchUserInfos();
  }, [apiUrl, token, countryList, isActive]);


  // Initialiser la méthode de paiement quand on change de pays alternatif
  // useEffect(() => {
  //   if (otherCountrySelected && alternativeCountryDetails) {
  //     setPaymentMethod(alternativeCountryDetails.payments[0]);
  //   }
  // }, [alternativeCountryDetails, otherCountrySelected]);

  //Synchronisation automatique du payment method
  useEffect(() => {
    if (!token || isActive) return;

    if (otherCountrySelected && alternativeCountryDetails?.payments?.length) {
      setPaymentMethod(alternativeCountryDetails.payments[0]);
    }
  }, [alternativeCountryDetails, otherCountrySelected, isActive, token]);

  // Déterminer les valeurs actuelles à utiliser
  const currentCountryDetails = otherCountrySelected
    ? alternativeCountryDetails
    : userBaseCountryDetails;

  const currentPhoneNumber = otherCountrySelected
    ? alternativePhoneNumber
    : userBasePhone;

  const currentCode = otherCountrySelected
    ? alternativeCountryDetails?.code
    : userBaseCode;

  // const verifyPayment = async () => {
  //   try {
  //     const verifyRes = await fetch(`${apiUrl}/api/activation/verify-payment`, {
  //       method: "GET",
  //       headers: {
  //         "Content-Type": "application/json",
  //         Authorization: `Bearer ${token}`,
  //       },
  //     });

  //     const verifyData = await verifyRes.json();

  //     if (verifyRes.ok && verifyData.isActive) {
  //       setIsActive(true);

  //       const user = JSON.parse(localStorage.getItem("user")) || {};
  //       user.isActive = true;
  //       localStorage.setItem("user", JSON.stringify(user));

  //       setSuccessMessage(verifyData.message || "Paiement confirmé. Compte activé !");
  //       setErrorMessage("");
  //     } else {
  //       setErrorMessage(verifyData.message || "Paiement non encore confirmé. Veuillez réessayer.");
  //     }
  //   } catch (error) {
  //     setErrorMessage("Erreur lors de la vérification du paiement");
  //   } finally {
  //     setIsLoading(false);
  //   }
  // };


  // Fonction pour gérer le paiement
  const handlePayment = async () => {
    setErrorMessage("");
    setSuccessMessage("");

    if (otherCountrySelected) {
      if (!alternativePhoneNumber || alternativePhoneNumber.length !== alternativeCountryDetails.digit) {
        setErrorMessage(`Veuillez entrer un numéro de téléphone valide (${alternativeCountryDetails.digit} chiffres)`);
        return;
      }
    }

    const fullPhoneNumber = otherCountrySelected ? alternativePhoneNumber : userBasePhone;

    setIsLoading(true);

    // console.log(fullPhoneNumber, paymentMethod, currentCountryDetails)
    try {
      // 1️⃣ Lancer le paiement
      const response = await fetch(`${apiUrl}/api/activation/activate`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify({
          tel: fullPhoneNumber,
          paymentMethod,
          country: currentCountryDetails.name,
          isoCode: currentCountryDetails.isoCode
        }),
      });

      const data = await response.json();
      if (!response.ok) throw new Error(data.message || "Échec du paiement");

      setSuccessMessage(data.message || "Paiement initié avec succès !");

      // 2️⃣ Vérifier immédiatement le paiement
      // setTimeout(() => {
      //   verifyPayment();
      // }, 60000) // 1 minute

    } catch (error) {
      setErrorMessage(error.message || "Une erreur est survenue lors du paiement");
      setIsLoading(false);
    }
  };


  return (
    <div className="space-y-4 pb-20 px-2 sm:px-0">

      {/*───────────────────────────────────────────────*/}
      {/* HEADER */}
      {/*───────────────────────────────────────────────*/}
      <div className="bg-gradient-to-r from-blue-500 to-purple-600 rounded-b-lg shadow-md p-4 md:p-6 text-white">
        <div className="flex items-center gap-3 mb-3">
          <div className="text-2xl md:text-3xl lg:text-4xl flex-shrink-0">💳</div>
          <div className="min-w-0">
            <h2 className="text-lg sm:text-xl md:text-2xl font-bold break-words">
              Activation du Compte
            </h2>
            <p className="text-xs sm:text-sm opacity-90">
              Dernière étape avant de commencer !
            </p>
          </div>
        </div>
        <div className="bg-white/20 rounded-lg p-3 mt-4">
          <div className="flex justify-between items-center flex-wrap gap-2">
            <span className="text-xs sm:text-sm">Frais d'activation :</span>
            <span className="text-xl sm:text-2xl font-bold">
              {activationFee.toLocaleString()} F CFA
            </span>
          </div>
        </div>
      </div>

      {/*───────────────────────────────────────────────*/}
      {/* MESSAGES D'ERREUR ET SUCCÈS */}
      {/*───────────────────────────────────────────────*/}
      {errorMessage && (
        <div className="bg-red-100 border border-red-400 text-red-700 px-4 py-3 rounded relative">
          <strong className="font-bold">Erreur ! </strong>
          <span className="block sm:inline">{errorMessage}</span>
          <button
            className="absolute top-0 bottom-0 right-0 px-4 py-3"
            onClick={() => setErrorMessage("")}
          >
            <span className="text-2xl">&times;</span>
          </button>
        </div>
      )}

      {successMessage && (
        <div className="bg-green-100 border border-green-400 text-green-700 px-4 py-3 rounded relative">
          <strong className="font-bold">Succès ! </strong>
          <span className="block sm:inline">{successMessage}</span>
        </div>
      )}

      {/*───────────────────────────────────────────────*/}
      {/* FORMULAIRE */}
      {/*───────────────────────────────────────────────*/}
      <div className="bg-white rounded-lg shadow-md p-4 md:p-6">
        <h3 className="text-base sm:text-lg md:text-xl font-bold mb-4">
          💸 Procéder au Paiement
        </h3>

        {/* NUMÉRO DE BASE */}
        <div className="mt-2 mb-4">
          <fieldset>
            <legend className="font-medium text-gray-700 mb-2 text-sm sm:text-base">
              Numéro de téléphone :
            </legend>

            {/* NUMÉRO PAR DÉFAUT */}
            <div
              className="flex gap-2 my-2"
              onClick={() => {
                selectOtherCountry(false);
                if (userBaseCountryDetails) {
                  setPaymentMethod(userBaseCountryDetails.payments[0]);
                }
              }}
            >
              <input
                type="radio"
                id="base"
                name="payment"
                checked={!otherCountrySelected}
                onChange={() => {
                  selectOtherCountry(false);
                  if (userBaseCountryDetails) {
                    setPaymentMethod(userBaseCountryDetails.payments[0]);
                  }
                }}
                className="cursor-pointer flex-shrink-0 mt-1"
              />

              <label
                htmlFor="base"
                className="font-medium cursor-pointer text-sm sm:text-base break-all"
              >
                {userBaseCountryDetails
                  ? `${userBasePhone}`
                  : "Chargement..."}
              </label>
            </div>

            {/* AUTRE NUMÉRO */}
            <div
              className="flex gap-2"
              onClick={() => {
                selectOtherCountry(true);
                setPaymentMethod(alternativeCountryDetails.payments[0]);
              }}
            >
              <input
                type="radio"
                id="other"
                name="payment"
                checked={otherCountrySelected}
                onChange={() => {
                  selectOtherCountry(true);
                  setPaymentMethod(alternativeCountryDetails.payments[0]);
                }}
                className="cursor-pointer flex-shrink-0 mt-1"
              />
              <label
                htmlFor="other"
                className="font-medium cursor-pointer text-sm sm:text-base"
              >
                Autre numéro
              </label>
            </div>
          </fieldset>
        </div>

        {/* CHOIX DU PAYS */}
        {otherCountrySelected && (
          <div className="mb-4">
            <label className="block font-medium text-gray-700 mb-2 text-sm sm:text-base">
              Pays
            </label>
            <select
              value={alternativeCountryDetails?.code}
              onChange={(e) => {
                const selectedCountry = countryList.find(
                  c => c.code === e.target.value
                );

                if (!selectedCountry) return;

                setAlternativeCountryDetails(selectedCountry);
                setAlternativePhoneNumber("");
              }}
              className="w-full px-3 py-3 md:py-2 border border-gray-300 rounded-md"
            >
              {countryList.map((country) => (
                <option key={country.code} value={country.code}>
                  {country.name}
                </option>
              ))}
            </select>

          </div>
        )}

        {/* NUMÉRO (SI AUTRE PAYS) */}
        {otherCountrySelected && alternativeCountryDetails && (
          <div className="mb-4">
            <div className="flex gap-2 mb-2 flex-wrap">
              <label
                className="font-medium text-gray-700 w-full sm:w-20 text-sm sm:text-base"
                htmlFor="code"
              >
                Indicatif
              </label>
              <label
                className="font-medium text-gray-700 text-sm sm:text-base"
                htmlFor="tel"
              >
                Numéro de téléphone
              </label>
            </div>

            <div className="flex gap-2">
              <input
                id="code"
                value={alternativeCountryDetails.code}
                className="w-16 sm:w-20 px-2 sm:px-3 py-3 md:py-2 border border-gray-300 rounded-md bg-gray-100 text-sm sm:text-base font-medium text-center"
                disabled
              />

              <input
                id="tel"
                type="tel"
                maxLength={alternativeCountryDetails.digit}
                placeholder={"x".repeat(alternativeCountryDetails.digit)}
                value={alternativePhoneNumber}
                onChange={(e) =>
                  setAlternativePhoneNumber(e.target.value.replace(/\D/g, ""))
                }
                className="flex-1 min-w-0 px-3 py-3 md:py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 text-sm sm:text-base"
              />
            </div>
          </div>
        )}

        {/* MÉTHODE DE PAIEMENT */}
        {currentCountryDetails && (
          <div className="mb-4">
            <label className="block text-sm font-medium text-gray-700 mb-2">
              Méthode de paiement
            </label>
            <select
              value={paymentMethod}
              onChange={(e) => setPaymentMethod(e.target.value)}
              className="w-full px-3 py-3 md:py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 text-sm sm:text-base"
            >
              {currentCountryDetails.payments.map((item, key) => (
                <option key={key} value={item}>
                  {item}
                </option>
              ))}
            </select>
          </div>
        )}

        {/* RÉCAP */}
        <div className="bg-gray-50 rounded-lg p-3 sm:p-4 mb-4">
          <h4 className="font-semibold text-gray-800 mb-3 text-sm sm:text-base">
            📋 Récapitulatif
          </h4>
          <div className="space-y-2 text-xs sm:text-sm">
            <div className="flex justify-between items-start gap-2">
              <span className="text-gray-600">Numéro :</span>
              <span className="font-medium text-right break-all max-w-[60%]">
                {(currentPhoneNumber + "").includes("+") ? "" : currentCode} {currentPhoneNumber}
              </span>
            </div>

            <div className="flex justify-between items-start gap-2">
              <span className="text-gray-600">Frais d'activation :</span>
              <span className="font-medium text-right">
                {activationFee.toLocaleString()} F
              </span>
            </div>

            <div className="flex justify-between items-start gap-2">
              <span className="text-gray-600">Méthode :</span>
              <span className="font-medium text-right break-words max-w-[60%]">
                {paymentMethod}
              </span>
            </div>

            <div className="border-t pt-2 flex justify-between items-start gap-2">
              <span className="font-bold text-gray-800">Total à payer :</span>
              <span className="font-bold text-blue-600 text-sm sm:text-lg text-right whitespace-nowrap">
                {activationFee.toLocaleString()} F CFA
              </span>
            </div>
          </div>
        </div>

        {/* BOUTON */}
        <button
          onClick={handlePayment}
          disabled={isLoading}
          className={`w-full ${isLoading
            ? 'bg-gray-400 cursor-not-allowed'
            : 'bg-gradient-to-r from-green-500 to-emerald-600 hover:from-green-600 hover:to-emerald-700 transform hover:scale-105'
            } text-white font-bold py-3 md:py-4 px-4 sm:px-6 rounded-lg transition-all duration-300 shadow-lg text-sm sm:text-base flex items-center justify-center gap-2`}
        >
          {isLoading ? (
            <>
              <div className="animate-spin rounded-full h-5 w-5 border-b-2 border-white"></div>
              <span>Traitement en cours...</span>
            </>
          ) : (
            <>
              <span>✅</span>
              <span>Confirmer le Paiement</span>
            </>
          )}
        </button>


        <p className="text-xs text-gray-500 text-center mt-3">
          Votre compte sera activé dans les plus brefs délais
        </p>
      </div>

      {/* AVANTAGES */}
      <div className="bg-white rounded-lg shadow-md p-4 md:p-6">
        <h3 className="text-base sm:text-lg font-bold text-gray-800 mb-3 flex items-center gap-2">
          ✨ Ce que vous obtenez
        </h3>
        <div className="space-y-3">
          <div className="flex items-start gap-3">
            <div className="text-xl sm:text-2xl flex-shrink-0">🎁</div>
          </div>
          <div className="flex items-start gap-3">
            <div className="text-xl sm:text-2xl flex-shrink-0">🔗</div>
            <div className="min-w-0">
              <p className="font-medium text-gray-800 text-sm sm:text-base">
                Lien d'invitation unique
              </p>
              <p className="text-xs sm:text-sm text-gray-600">
                Commencez à parrainer et gagner
              </p>
            </div>
          </div>
          <div className="flex items-start gap-3">
            <div className="text-xl sm:text-2xl flex-shrink-0">💰</div>
            <div className="min-w-0">
              <p className="font-medium text-gray-800 text-sm sm:text-base">
                Système de commissions
              </p>
              <p className="text-xs sm:text-sm text-gray-600">
                1400F, 600F, 300F sur 3 niveaux
              </p>
            </div>
          </div>
          <div className="flex items-start gap-3">
            <div className="text-xl sm:text-2xl flex-shrink-0">📚</div>
            <div className="min-w-0">
              <p className="font-medium text-gray-800 text-sm sm:text-base">
                Accès aux formations
              </p>
              <p className="text-xs sm:text-sm text-gray-600">
                Marketing digital gratuit
              </p>
            </div>
          </div>
        </div>
      </div>

      {/* SUPPORT */}
      <div className="bg-yellow-50 border-l-4 border-yellow-500 rounded-lg p-4">
        <div className="flex items-start gap-3">
          <div className="w-full">
            <h4 className="font-bold text-yellow-800 mb-1 text-sm sm:text-base">
              Besoin d'aide ?
            </h4>
            <p className="text-xs sm:text-sm text-yellow-700 mb-2">
              Notre équipe est disponible pour vous assister
            </p>

            <div className="mt-4 space-y-6">
              <div>
                <div className="flex flex-col sm:flex-row items-center gap-4 sm:gap-6 md:gap-10">
                  <div className="text-center sm:text-left min-w-0 flex-1">
                    <h2 className="text-base sm:text-lg md:text-xl font-bold">
                      Administrateur
                    </h2>
                    <p className="text-xs sm:text-sm md:text-base">
                      Adressez vos problèmes techniques
                    </p>
                  </div>
                  <div className="animate-flotter flex-shrink-0">
                    <SiGmail className="text-red-800 w-12 h-12 sm:w-16 sm:h-16 md:w-20 md:h-20" />
                  </div>
                </div>

                <button
                  className="mt-4 bg-slate-800 text-white py-2 px-4 w-full sm:w-40 rounded-md text-sm sm:text-base"
                  onClick={() =>
                    window.open(
                      "mailto:capitalyanet@gmail.com?subject=Support&body=Bonjour,"
                    )
                  }
                >
                  Cliquer-ici
                </button>
              </div>

              <div>
                <div className="flex flex-col sm:flex-row items-center gap-4 sm:gap-6 md:gap-10">
                  <div className="text-center sm:text-left min-w-0 flex-1">
                    <h2 className="text-base sm:text-lg md:text-xl font-bold">
                      Support Client
                    </h2>
                    <p className="text-xs sm:text-sm md:text-base">
                      Écrivez-nous sur WhatsApp
                    </p>
                  </div>
                  <div className="animate-flotter flex-shrink-0">
                    <FaWhatsappSquare className="text-[#25D366] w-12 h-12 sm:w-16 sm:h-16 md:w-20 md:h-20" />
                  </div>
                </div>

                <button
                  className="mt-4 bg-slate-800 text-white py-2 px-4 w-full sm:w-40 rounded-md text-sm sm:text-base"
                  onClick={() =>
                    window.open(
                      "https://wa.me/22890974255?text=Bonjour",
                      "_blank"
                    )
                  }
                >
                  Cliquer-ici
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>

    </div>
  );
}